import { render, staticRenderFns } from "./ReportViewPresentation.vue?vue&type=template&id=51ca4c09&scoped=true&"
import script from "./ReportViewPresentation.vue?vue&type=script&lang=js&"
export * from "./ReportViewPresentation.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewPresentation.vue?vue&type=style&index=0&id=51ca4c09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca4c09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VTooltip,
})
